var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 8.233,
  height: 13.861,
  viewBox: "0 -4.861 8.233 13.861"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.233 2.018 1.251 9 0 7.645l5.627-5.627L0-3.61l1.251-1.25z"
})));
export default SvgArrow;